export default __webpack_public_path__ + "static/media/ok.81004562.mp3";